import * as React from "react";
import {Link} from "react-router-dom";

class Element extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            link: '/admin' + this.props.link
        };
    }

    isActive() {
        return this.props.link.split('/')[1] === window.location.pathname.replace(/^\/admin\//, '').split('/')[0];
    }

    render() {
        return (
            <li key = {this.state.link} className={`nav-link ${this.isActive() ? "active" : ""}`} >
                <Link className="nav-link" to={this.state.link}>{this.props.children}</Link>
            </li>
        );
    }

}

export default Element;